import { useSyncExternalStore } from 'react';

/**
 * Quick-create drawers that open over the current page (QBO: + New › Customer, Vendor,
 * Product/service, and "+ Add new" in pickers). One request at a time.
 */
export interface NewDrawerRequest {
  kind: 'customer' | 'vendor' | 'item';
  /** Prefills the name (what was typed in a picker). */
  name?: string;
  /** Lets the user choose customer or vendor (the journal entry "Name" picker). */
  chooseKind?: boolean;
  onSaved?: (saved: { id: string; label: string }) => void;
}

let current: NewDrawerRequest | null = null;
const listeners = new Set<() => void>();

export function openNewDrawer(request: NewDrawerRequest): void {
  current = request;
  listeners.forEach((l) => l());
}

export function closeNewDrawer(): void {
  current = null;
  listeners.forEach((l) => l());
}

export function useNewDrawer(): NewDrawerRequest | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
